import { useContext } from 'react';

import { ModalDispatchContext } from '../../contexts/ModalContext';

import type { ModalComponentProps, ModalStateParams } from '../../contexts/ModalContext';

export default function useModal() {
  const { open, close } = useContext(ModalDispatchContext);

  const openModal = <TModal extends ModalComponentProps = ModalComponentProps>(
    targetModal: ModalStateParams<TModal>,
  ) => {
    open(targetModal);
  };

  const closeModal = <TModal extends ModalComponentProps = ModalComponentProps>(
    targetModal: ModalStateParams<TModal>,
  ) => {
    close(targetModal);
  };

  return { openModal, closeModal };
}
